export const KEYCODE_UP_ARROW = 38;
export const KEYCODE_DOWN_ARROW = 40;
export const KEYCODE_LEFT_ARROW = 37;
export const KEYCODE_RIGHT_ARROW = 39;
export const KEYCODE_TAB = 9;
export const KEYCODE_ESCAPE = 27;
export const KEYCODE_ENTER = 13;
